import { Box, Button, Card, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import customerActions from "../../redux/customer/actions";
import ConsolidateTable from "../../common/consolidateTable";
import NoOfAttemptsTable from "../../common/noOfAttemptsTable";

export default function Index() {
  const dispatch = useDispatch();
  const { noOfAttemptsReport } = useSelector((state) => state.customerReducer);
  const currentYear = new Date().getFullYear();

  useEffect(() => {
    dispatch({ type: customerActions.GET_NOOFATTEMPTS_REPORT });
  }, []);

  let applicationStatusColumns = [
    {
      name: "Sr.No",
      dataIndex: "srNo",
    },
    {
      name: "Course Name",
      dataIndex: "coursename",
    },
    {
      name: "Registration In Progress",
      dataIndex: "registrationinprogress",
    },
    {
      name: "Fees Paid and Confirmed",
      dataIndex: "feepaid",
    },
    {
      name: "First Attempt",
      dataIndex: "firstattempt",
    },
    {
      name: "Both Attempt",
      dataIndex: "bothattempt",
    },
  ];


  const applicationStatusData = Array.isArray(noOfAttemptsReport)
    ? noOfAttemptsReport.map((item, index) => ({
        srNo: index + 1,
        coursename: item.coursename,
        registrationinprogress: item.registrationinprogress,
        feepaid: item.feepaid,
        firstattempt: item.firstattempt,
        bothattempt: item.secondattempt,
      }))
    : [];


  const totalData = {
    registrationinprogress: applicationStatusData.reduce(
      (sum, item) => sum + parseInt(item.registrationinprogress || 0, 10),
      0
    ),
    feepaid: applicationStatusData.reduce(
      (sum, item) => sum + parseInt(item.feepaid || 0, 10),
      0
    ),
    firstattempt: applicationStatusData.reduce(
      (sum, item) => sum + parseInt(item.firstattempt || 0, 10),
      0
    ),
    bothattempt: applicationStatusData.reduce(
      (sum, item) => sum + parseInt(item.bothattempt || 0, 10),
      0
    ),
  };

  return (
    <>
      <Box
        sx={{
          margin: "1rem auto",
          backgroundColor: "rgba(255, 255, 255, 1)",
          borderRadius: "8px",
          padding: "10px",
        }}
      >
        <Card sx={{ p: 2 }}>
          <Typography>No. Of Attempts Report</Typography>

          <Box sx={{ marginTop: 2 }}>
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: "500",
                color: "black",
                fontSize: "20px",
                lineHeight: "24px",
                mb: 1,
                backgroundColor: "whitesmoke",
                padding: "8px",
                borderRadius: "4px",
              }}
            >
              CET {currentYear} No. Of Attempts Report{" "}
            </Typography>
          </Box>

          <NoOfAttemptsTable
            columnData={applicationStatusColumns}
            tableData={applicationStatusData}
            totalData={totalData}
          />
        </Card>
      </Box>
    </>
  );
}
